import React from "react";
import { FaCube } from "react-icons/fa";
import styles from "./CardList.module.css";

const BlockCardSkeleton: React.FC = () => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.375rem" }}>
          <FaCube size={14} color="#3b82f6" />
          <div
            className={styles.skeleton}
            style={{ width: "5rem", height: "0.875rem" }}
          />
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Txn</span>
          <div
            className={styles.skeleton}
            style={{ width: "2.5rem", height: "0.875rem" }}
          />
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Reward</span>
          <div
            className={styles.skeleton}
            style={{ width: "6.25rem", height: "0.875rem" }}
          />
        </div>
        <div className={styles.cardRow} style={{ justifyContent: "flex-end" }}>
          <div
            className={styles.skeleton}
            style={{ width: "3rem", height: "0.875rem" }}
          />
        </div>
      </div>
    </div>
  );
};

export default BlockCardSkeleton;
